import { Instrumentation } from '@mews-framework/observability';
import { FeatureFlag } from '@mews-distributor/common';
import { logSentryError } from '../sentry/sentry';
import { getAppConfiguration, getVersion } from '../modules/configuration/selectors';
import { DistributorThunkAction } from '../types';

export const initializeInstrumentation =
    (): DistributorThunkAction =>
    (dispatch, getState, { featureFlagService }) => {
        try {
            if (!__LOCALHOST__ && featureFlagService.hasFlag(FeatureFlag.bookingEngineObservabilityEnabled)) {
                const state = getState();
                const { environment } = getAppConfiguration(state);
                const appVersion = getVersion();

                Instrumentation.createInstrumentation({
                    fullSamplingEnabled: featureFlagService.hasFlag(
                        FeatureFlag.bookingEngineObservabilityFullSamplingEnabled
                    ),
                    service: 'booking-engine-fe',
                    version: appVersion,
                    env: environment,
                    updateLabelsOnBeforeSend: false,
                    updateUserContextOnBeforeSend: false,
                });
            }
        } catch (error) {
            dispatch(logSentryError({ error, extra: { context: 'initializeInstrumentation' } }));
        }
    };
